import emotionStyled, { CreateStyled } from '@emotion/styled';
import { CSSProperties, ReactNode } from 'react';


export interface IColor {
  B50: string;
  B75: string;
  B100: string;
  B200: string;
  B300: string;
  B400: string;
  B500: string;
  BLACK: string;
  DB100: string;
  G100: string;
  DG100: string;
  G200: string;
  G300: string;
  G400: string;
  G500: string;
  G600: string;
  DG600: string;
  G700: string;
  G800: string;
  R50: string;
  R75: string;
  R100: string;
  R200: string;
  R300: string;
  R400: string;
  R500: string;
  DR500: string;
  WHITE: string;
}

export enum Theme {
  LIGHT = 'light',
  DARK = 'dark',
}

export interface IBreakpoints {
  mobile: string;
  tablet: string;
  laptop: string;
  desktop: string;
};

export interface IBaseTheme {
  unitSize: number;
  itemHeight: number;
  itemCompactHeight: number;
  itemSmallHeight: number;
  borderRadius: number;
  breakpoints: IBreakpoints;
}

export interface ITheme extends IBaseTheme {
  name: Theme;
  colors: {
    primary: string;
    secondary: string;
    appBgColor: string;
  };
}

export interface IComponentTheme {
  [Theme.LIGHT]: CSSProperties;
  [Theme.DARK]: CSSProperties;
}

export interface IUnfoldTheme<ComponentStructure> {
  [Theme.DARK]: ComponentStructure;
  [Theme.LIGHT]?: ComponentStructure;
}

type TValueOf<T> = T[keyof T];
export type TColorOption = {
  dark: TValueOf<IColor>;
  light?: TValueOf<IColor>;
};

export interface ICssTheme extends CSSProperties {
  theme?: ITheme;
  noWrap?: boolean;
  children?: ReactNode;
}

export interface IUnitFunction<T> {
  (multiplier?: number): (props: any) => T;
}
export interface IUnit extends IUnitFunction<number> {
  px: IUnitFunction<string>;
}

export type TJustify =
  | 'flex-start'
  | 'center'
  | 'flex-center'
  | 'flex-end'
  | 'space-between'
  | 'space-around'
  | 'space-evenly'
  | undefined;

export type TAlignItems =
  | 'flex-start'
  | 'center'
  | 'flex-end'
  | 'stretch'
  | 'baseline'
  | undefined;

export type TDirection = 'row' | 'column' | undefined;

export type TFlexWrap = 'nowrap' | 'wrap' | undefined;

export const styled = emotionStyled as CreateStyled<ITheme>;
